"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PaymentDetailsSummary {
}
exports.default = PaymentDetailsSummary;
//# sourceMappingURL=PaymentDetailsSummary.js.map